// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PaymentKeyboard_wrapper__23tuQ","nextButton":"PaymentKeyboard_nextButton__1aTdQ"};